import { Directive } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { OnInit } from '@angular/core';
import { Input } from '@angular/core';

import { Validator, ValidatorBase } from '../core/model';

@Directive({
    selector: '[checkbox-validator]',
    host: { '(change)': 'changed($event)' },
    exportAs: 'validator'
})
export class CheckboxValidatorDirective extends ValidatorBase implements OnInit, Validator
{
    @Input('checkbox-validator')
    public getValue: () => string;
    public valid: boolean;

    public constructor(viewRef: ViewContainerRef)
    {
        super(viewRef);
    }

    public changed(event: any): void
    {
        this.validate();
    }

    public ngOnInit(): void { }

    protected isValid(): boolean
    {
        return this.elementRef.checked;
    }
}
